import React, {useEffect, useRef, useState} from "react";
import mapboxgl from 'mapbox-gl';
import { makeStyles } from '@material-ui/core/styles';
import { createPortal } from "react-dom";
import MarcadorGoT from "./Marcador2";
import 'mapbox-gl/dist/mapbox-gl.css';
import Popup from "./popup";
import PopupOtb from "./popupOTB";
const useStyles = makeStyles({
    miclase:{".map-container":{
        height: "400px",
      }},
  });
 

function Mapa({lista, listMarcador, listGeoJDto,listColOtb, listNumOtb  }) {

    
    const classes = useStyles();
    const mapContainer = useRef(null);
    const mapRef = useRef(null);
    const markerRef = useRef()
    const [long] = useState(-66.15880049066588); 
    const [lat] = useState(-17.39642560364779);
    const [zoom] = useState(10.5);       
 
    const [regisPopUp, setRegisPopUp] = useState([]);
    const [listaDto, setListaDto] = useState([]);
    const [regisPopUpOtb, setRegisPopUpOtb] = useState([]);
    const [listaNum, setListaNum] = useState([]);
    const [hoveredDistrict, _setHoveredDistrict] = useState(null);
     
    let hoveredStateId = null;
    let stateName = null;

 
    useEffect(() => {       
        //console.log(typeof lista, lista);
       //console.log(listGeoJDto);
        
        mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_KEY;
        mapRef.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: "mapbox://styles/mapbox/light-v10",
            center: [long, lat],
            zoom: zoom            
        });

         
        //mapRef.addControl(new mapboxgl.NavigationControl());
       /*  mapRef.current.on('click', (e) => {                
            e.preventDefault()
            let nvoMarcador=[]
            //nvoMarcador=regisSelect           
            const geometry = { coordinates:[e.lngLat.lng.toFixed(5), e.lngLat.lat.toFixed(5)] } 
            const properties = {texto:"prueba"}    
            nvoMarcador= {geometry,properties,original:{Id:contador}}
           // console.log( contador, nvoMarcador);
            let auxLocalStg =  localStorage.getItem('auxPol') ?  JSON.parse(localStorage.getItem('auxPol')):[]
            if (auxLocalStg.length!==0) {
                //console.log(auxLocalStg);
                
                auxLocalStg.push(nvoMarcador)
                localStorage.setItem('auxPol',JSON.stringify(auxLocalStg))
            }
            else{
                localStorage.setItem('auxPol',JSON.stringify([nvoMarcador]))
            }
            
            setActualiza()
            setContador(contador+1)               
        }); */

       setListaDto(listGeoJDto)

        return () => {
            mapRef.current.remove()
        }
    }, [    ]);

     useEffect(()=>{
      
                
       if (listaDto.length!==0) {
       //console.log(listColOtb);
        
        const auxCoordenadas=listGeoJDto
   
        mapRef.current.on('load', () => {
            // Add a data source containing GeoJSON data.
            mapRef.current.addSource('dtos', {
                'type': 'geojson',
                'data':auxCoordenadas 
            });

            // Add a new layer to visualize the polygon.
            mapRef.current.addLayer({
                'id': 'fill-dtos',
                'type': 'fill',
                'source': 'dtos', // reference the data source
                'layout': {},
                'paint': {
                    'fill-color': listColOtb,//'#caebe1', // blue color fill
                    'fill-opacity': 0.5
                }
            });
            // Add a black outline around the polygon.
            mapRef.current.addLayer({
                'id': 'outline-dtos',
                'type': 'line',
                'source': 'dtos',
                'layout': {},
                'paint': {
                    'line-color': listColOtb,//["match",["get", "IdDto"],[81],'#eb4034',[82],"#97ca7f",'#cedded'],
                    'line-width': 3
                }
            });
            });
             
            setListaNum(listNumOtb)
        }
 
    },[listGeoJDto, listaDto ])

    const onClickUnidad=(aux)=>{
        
        //console.log(aux);
        const nvo={...aux,
            properties:{texto: aux.nom, dir: aux.dir, 
                otb:aux.otbNom},
            geometry:{coordinates:aux.coordinates}}
  
        setRegisPopUp(nvo)
    }


    return (
    <div className={classes.miclase} style={{width:"30rem",height: window.innerHeight - 140}} >
       
        {<div id="districtDetailMapBox" className={"map"} >
            <div style={{width:"30rem", height: window.innerHeight - 140}} ref={mapContainer}>
            </div>
   
            {  listaNum.length !== 0 ?
                listaNum.map((elemento,index)=>{
                const estilo = parseInt(elemento.DtNom) < 10 ?{width:"20px", height:"35px"}:{width:"30px", height:"38px"}
                    return<MarcadorGoT
                    key={elemento.id}
                    map={mapRef.current}
                    feature={elemento}
                    onClick={onClickUnidad}
                    estilo={estilo}
                    url={`https://daduva-cartografia.sfo3.cdn.digitaloceanspaces.com/Sec/Secc${elemento.DtNom}.svg`}
                /> }
                )
               
            :null  }                    

             {mapRef.current && regisPopUp.length!==0 ? (
                <PopupOtb
                    map={mapRef.current}
                    activeFeature={regisPopUp}
                />
            )
            :null}
        </div>}
    </div>
    );
}

export default Mapa;